var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33337 0.666748C5.70156 0.666748 6.00004 0.965225 6.00004 1.33341V2.00008H10V1.33341C10 0.965225 10.2985 0.666748 10.6667 0.666748C11.0349 0.666748 11.3334 0.965225 11.3334 1.33341V2.00008H12.6667C13.7713 2.00008 14.6667 2.89551 14.6667 4.00008V13.3334C14.6667 14.438 13.7713 15.3334 12.6667 15.3334H3.33337C2.2288 15.3334 1.33337 14.438 1.33337 13.3334V4.00008C1.33337 2.89551 2.2288 2.00008 3.33337 2.00008H4.66671V1.33341C4.66671 0.965225 4.96518 0.666748 5.33337 0.666748ZM4.66671 3.33341H3.33337C2.96518 3.33341 2.66671 3.63189 2.66671 4.00008V6.00008H13.3334V4.00008C13.3334 3.63189 13.0349 3.33341 12.6667 3.33341H11.3334V4.00008C11.3334 4.36827 11.0349 4.66675 10.6667 4.66675C10.2985 4.66675 10 4.36827 10 4.00008V3.33341H6.00004V4.00008C6.00004 4.36827 5.70156 4.66675 5.33337 4.66675C4.96518 4.66675 4.66671 4.36827 4.66671 4.00008V3.33341ZM13.3334 7.33341H2.66671V13.3334C2.66671 13.7016 2.96518 14.0001 3.33337 14.0001H12.6667C13.0349 14.0001 13.3334 13.7016 13.3334 13.3334V7.33341Z",
    fill: "#18181B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f9d842af4689dc9f13f969660cfae080.svg";
export { ForwardRef as ReactComponent };